// --- Core ---
import {FC} from "react";
// --- Material UI ---
import {SvgIconProps} from "@mui/material";
import {
  AssignmentOutlined,
  AttachFile,
  Ballot,
  BubbleChart,
  CellTower,
  Checklist,
  ContactMail,
  ContactPageTwoTone,
  CorporateFare,
  Extension,
  Groups2,
  LabelOutlined,
  LibraryBooks,
  LocalHospital,
  LocationCity,
  MedicalInformation,
  Person,
  ShowChart,
  Topic,
  VideocamRounded
} from "@mui/icons-material";
import {AccountTag} from "mdi-material-ui";
// --- SaniQ ---
import {JSONAPIReference} from "../../models/Helpers";

interface ModelIconTypeProps extends SvgIconProps {
  type: string;
}

interface ModelIconRelationProps extends SvgIconProps {
  relation: JSONAPIReference;
}

const ModelIcon: FC<ModelIconTypeProps | ModelIconRelationProps> = ({relation, type, ...rest}: ModelIconTypeProps & ModelIconRelationProps) => {
  switch (type || relation?.type) {
    case "drug":
    case "patient_drug":
    case "pzn_drug":
      return <BubbleChart {...rest}/>;
    case "document":
    case "finding":
      return <AttachFile {...rest}/>;
    case "health_provider":
    case "patient_health_provider":
      return <LocalHospital {...rest}/>;
    case "institution":
      return <CorporateFare {...rest}/>;
    case "patient_measurement":
      return <ShowChart {...rest}/>;
    case "measurement_group":
      return <CellTower {...rest}/>;
    case "medical_billing":
      return <MedicalInformation {...rest}/>;
    case "medium":
      return <Topic {...rest}/>;
    case "patient_icd10":
      return <LabelOutlined {...rest}/>;
    case "patient":
      return <ContactPageTwoTone {...rest}/>;
    case "person":
      return <ContactMail {...rest}/>;
    case "physician":
      return <Person {...rest}/>;
    case "patient_program":
    case "program":
      return <LibraryBooks {...rest}/>;
    case "program_component":
      return <Extension {...rest}/>;
    case "role":
      return <Groups2 {...rest}/>;
    case "survey":
    case "patient_survey":
      return <Ballot {...rest}/>;
    case "cohort":
    case "tag":
      return <AccountTag {...rest}/>;
    case "patient_task":
      return <Checklist {...rest}/>;
    case "task":
      return <AssignmentOutlined {...rest}/>;
    case "video_consultation":
      return <VideocamRounded {...rest}/>;
    case 'address':
      return <LocationCity/>;
    default:
      return null;
  }
};

export {
  ModelIcon
};
